import { render, staticRenderFns } from "./MoneySaved.vue?vue&type=template&id=5bfb773b&scoped=true&"
import script from "./MoneySaved.vue?vue&type=script&lang=js&"
export * from "./MoneySaved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb773b",
  null
  
)

export default component.exports